<div
  class="visual-builder-block products-feed-item"
  [class.selected]="selectedId?.id === placement + 'ProductsFeedCard'"
>
  <div
    class="movement-block movement-block-products-feed-item p-0 m-0"
    [ngStyle]="{
      boxShadow: itemStyles?.shadow,
      borderColor: itemStyles?.borderColor,
      backgroundColor: itemStyles?.backgroundColor,
      'borderWidth.px': itemStyles?.borderWidth,
      'borderRadius.px': itemStyles?.borderRadius
    }"
    (click)="
      selectItem(
        $event,
        button,
        buttonText,
        title,
        price,
        titleSpan,
        priceSpan1,
        priceSpan2
      )
    "
  >
    <div
      class="product-image"
      [ngStyle]="{
        'maxWidth.px': itemStyles.imageWidth || 120,
        'maxHeight.px': itemStyles.imageHeight || 120
      }"
    >
      <img
        [src]="productItem.imageUrl"
        [alt]="productItem.title"
        [ngStyle]="{ 'borderRadius.px': itemStyles.imageBorderRadius }"
      />
    </div>
    <div
      class="visual-builder-block product-title"
      #title
      [ngStyle]="{ textAlign: itemStyles?.title?.alignment || 'left' }"
    >
      <span
        #titleSpan
        class="title-text"
        [ngStyle]="
          itemStyles.title
            | fontFamily
            | assign
              : {
                  'fontSize.px': itemStyles.title.fontSize,
                  'lineHeight.px': itemStyles.title.fontSize * 1.21
                }
        "
        >{{
          productItem.title.length > 23
            ? productItem.title.substr(0, 20) + '...'
            : productItem.title
        }}</span
      >
    </div>
    <div
      #price
      class="visual-builder-block product-price"
      [ngStyle]="{ textAlign: itemStyles?.regularPrice?.alignment || 'left' }"
    >
      <span
        #priceSpan2
        class="regular-price"
        [ngStyle]="
          itemStyles.regularPrice | fontFamily | assign : regularPriceStyles
        "
        >{{ productItem.regularPrice || '' }}</span
      >
      <span
        #priceSpan1
        class="discounted-price"
        [ngStyle]="
          itemStyles.discountedPrice
            | fontFamily
            | assign
              : {
                  'fontSize.px': itemStyles.discountedPrice.fontSize,
                  'lineHeight.px': itemStyles.discountedPrice.fontSize * 1.21
                }
        "
        >{{ productItem.discountedPrice || '' }}</span
      >
    </div>
    <div class="product-action">
      <div class="visual-builder-block">
        <a
          #button
          class="btn btn-default btn-lightish-blue text-capitalize btn-details min-w mb-0 btn-slider-buy-now"
          [ngStyle]="itemStyles.button | fontFamily | assign : buttonStyles"
          [attr.href]="productItem.buttonUrl"
          [title]="
            (itemStyles.buttonText || 'Buy Now') + ' ' + productItem.title
          "
          target="_blank"
          (click)="onAnchorClick($event)"
        >
          <span #buttonText>
            {{ itemStyles.buttonText || 'Buy Now' }}
          </span>
        </a>
      </div>
    </div>
    <!-- /movement-block-content -->
  </div>
</div>
